import axios from 'axios';
import { IAddress } from '../models/Account/IAddress';
import { IAuthChange } from '../models/Account/IAuthChange';
import { IPhone } from '../models/Account/IPhone';
import { commonService } from './commonDashboardApiService';
import { ICommPreference } from '../models/Account/ICommPreference';

function accountService() {
  const localInstance = axios.create({
    baseURL: '/',
    timeout: 120000,
    headers: {
      'Content-Type': 'application/json',
      Accept: '*/*',
    },
    withCredentials: false,
  });

  function getAccount<IAccount>(id: string) {
    return commonService.get<IAccount>('api/account/get', {
      params: { memberId: id, ssoUUId: id },
    });
  }

  function getMembershipCertificateData(memberId: string, ssoUUId: string) {
    return commonService.get('api/membership/GetMembershipCertificate', {
      params: { memberId: memberId, ssoUUId: ssoUUId },
    });
  }

  function getContactEditData<IContactEdit>() {
    return commonService.get<IContactEdit>('api/account/GetContactEditData');
  }

  function getContactConfigData<IContactConfig>(countryCode: string = 'US') {
    return commonService.get('api/account/GetContactConfigData', {
      params: { countryCode: countryCode },
    });
  }

  function saveAddress(id: string, data: IAddress) {
    return commonService.put(`api/account/SaveAddress?memberId=${id}`, data);
  }

  function saveEmailPassword(authChange: IAuthChange) {
    return localInstance.post('api/tokenforpasswordemailchange', authChange).then(response => {
      return commonService.post('api/account/ChangeAccountEmailWithToken', response.data);
    });
  }

  function savePhone(id: string, data: IPhone) {
    return commonService.put<IPhone>('api/account/savePhone', data, {
      params: { memberId: id },
    });
  }

  function getStatesForCountry<IBasicItem>(countryCode: string = 'US') {
    return commonService.get('api/account/GetStatesForCountry', {
      params: { countryCode: countryCode },
    });
  }

  function getAllEntries<IEntry>(memberId: string, ssoUUId: string) {
    return commonService.get('api/entry/GetAll', {
      params: { memberId: memberId, ssoUUId: ssoUUId },
    });
  }

  function saveHrMagazineSubscription(memberId: string, editionType: number) {
    return commonService.post(
      `api/account/setHrMagazineSubscription?memberId=${memberId}&editionType=${editionType}`
    );
  }

  function updatePreferences(memberId: string, commPreferences: ICommPreference) {
    try {
      return commonService.post(
        `api/account/UpdateCommPreferences?memberId=${memberId}`,
        JSON.stringify(commPreferences)
      );
    } catch (error) {
      return Promise.reject(error);
    }
  }

  return {
    getAccount,
    getContactEditData,
    getContactConfigData,
    getMembershipCertificateData,
    getStatesForCountry,
    saveAddress,
    saveEmailPassword,
    savePhone,
    getAllEntries,
    saveHrMagazineSubscription,
    updatePreferences,
  };
}

export default accountService;
